module.exports = __webpack_public_path__ + "img/show.08efc493.png";